const { $ } = window;

export default class DataTable {
	constructor(selector, cols, data, pagination, ordering) {

		this.selector = selector
		
		let table = $(selector);

		let options = {
			data: data,
			columns: cols,

			"language": {
				"aria": {
					"sortAscending": ": activate to sort column ascending",
					"sortDescending": ": activate to sort column descending"
				},
				"emptyTable": "No data available in table",
				// "info": "Showing _START_ to _END_ of _TOTAL_ records",
				"infoEmpty": "No records found",
				"infoFiltered": "(filtered1 from _MAX_ total records)",
				"lengthMenu": "Show _MENU_",
				"search": "Search:",
				"zeroRecords": "No matching records found",
				"paginate": {
					"previous":"Prev",
					"next": "Next",
					"last": "Last",
					"first": "First"
				},
			},

			"paging": false,
			"searching": false,
		};

		if(pagination) {
			options.paging = true;
			options.searching = true;
		}

		if(ordering !== undefined) {
			options.ordering = ordering
		}

		setTimeout(() => {
			this.table = table.dataTable(options);

			let tableWrapper = $(selector + '_wrapper');

			table.find('.group-checkable').change(function () {
				let set = $(this).attr("data-set");
				let checked = $(this).is(":checked");
				$(set).each(function () {
					if (checked) {
						$(this).prop("checked", true);
						$(this).parents('tr').addClass("active");
					} else {
						$(this).prop("checked", false);
						$(this).parents('tr').removeClass("active");
					}
				});
			});

			table.on('change', 'tbody tr .checkboxes', function () {
				$(this).parents('tr').toggleClass("active");
			});
		}, 0)
	}

	rerender(newData, newCols) {

		if(newCols && newCols.length) {
			for(let i in newCols) {
				this.table.DataTable().columns(i).header().to$().text(newCols[i])
			}
			this.table.DataTable().columns.adjust().draw();
		}

		this.table.DataTable().clear();
		this.table.DataTable().rows.add(newData).draw();
	}

	destroy() {
		this.table.DataTable().destroy()
		$(this.selector).empty()
	}
}


// WEBPACK FOOTER //
// ./src/helper/datatable.helper.js